import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useDispatch } from 'react-redux';

import { getDateFormat } from '../../_helpers/useful-functions';
import { IAsideMenu } from '../../models/moments-report/aside-menu';
import { useAppSelector } from '../../store';
import {
    getMomentReportsDashboardFeed,
    getMomentReportsGropuTitleGrid,
    setCompanyListToReportFilter,
    setGroupTitle,
    setNotificationTitle,
    setNotificationType,
    setPageMenuType,
    setSubPage,
} from '../../store/features/moments-reports/momentReportsSlice';

const AsideMenu = ({ item, activeMenuType, setActiveMenuType }: IAsideMenu) => {
    const [expanded, setExpanded] = useState<string | false>('panel1');
    const dispatch = useDispatch();
    const { filterModalOpen } = useAppSelector(state => state.momentReports);

    const { reportFilter, notficationType, page, isValidate, companyAllListWithLabelValue, gridTableGroupTitle } = useAppSelector(
        state => state.momentReports,
    );
    const { pageIndex } = useAppSelector(state => state.momentReports.gridTableGroupTitle);

    useEffect(() => {
        if (reportFilter?.companyIdList?.length === 0) dispatch(setCompanyListToReportFilter(companyAllListWithLabelValue?.items));
    }, []);
    useEffect(() => {
        if (filterModalOpen) {
            setExpanded(false);
        }
    }, [filterModalOpen]);

    const handleChange = (panel: string) => (event, newExpanded_: boolean) => {
        setExpanded(newExpanded_ ? panel : false);
    };

    const handleClickToSubPage = reportMenuType_ => {
        if (reportMenuType_ === 0) {
            dispatch(setSubPage('dashboard-feed'));
        } else if (reportMenuType_ === 2) {
            dispatch(setSubPage('notifications-grid'));
        } else if (reportMenuType_ === 3) {
            dispatch(setSubPage('groupTitle-grid'));
        }
    };

    const handleClickToFeed = ({ title = '', leftMenuInfoType = null, itemGroupTitle = null, serviceUrl = null, excelType = null }) => {
        dispatch(setPageMenuType(item?.reportMenuType));
        handleClickToSubPage(item?.reportMenuType);
        dispatch(setNotificationTitle(title));
        dispatch(setNotificationType(leftMenuInfoType));
        dispatch(
            setGroupTitle({
                ...gridTableGroupTitle,
                startDate: getDateFormat({ date_: reportFilter?.startDate }),
                endDate: getDateFormat({ date_: reportFilter?.endDate }),
                serviceUrl: itemGroupTitle ? itemGroupTitle?.serviceUrl : serviceUrl,
                companyIdList: reportFilter?.companyIdList,
                type: itemGroupTitle ? itemGroupTitle?.leftMenuDetailsType : leftMenuInfoType,
                excelType: excelType,
                loading: false,
            }),
        );
        if (reportFilter?.companyList?.length > 0 && isValidate) {
            if (item?.reportMenuType === 2 && !(leftMenuInfoType === 10 || leftMenuInfoType === 11 || leftMenuInfoType === 12)) {
                dispatch(
                    getMomentReportsGropuTitleGrid({
                        startDate: getDateFormat({ date_: reportFilter?.startDate }),
                        endDate: getDateFormat({ date_: reportFilter?.endDate }),
                        serviceUrl: itemGroupTitle ? itemGroupTitle?.serviceUrl : serviceUrl,
                        companyIdList: reportFilter?.companyIdList,
                        type: itemGroupTitle ? itemGroupTitle?.leftMenuDetailsType : leftMenuInfoType,
                        excelType: excelType,
                        pageSize: 50,
                        pageIndex,
                    }),
                );
            } else if (item?.reportMenuType === 0) {
                dispatch(
                    getMomentReportsDashboardFeed({
                        startDate: getDateFormat({ date_: reportFilter?.startDate }),
                        endDate: getDateFormat({ date_: reportFilter?.endDate }),
                        companyList: reportFilter?.companyIdList,
                    }),
                );
            }
        }
        //!groupTitle get data
        if (item?.reportMenuType === 1 || item?.reportMenuType === 3 || leftMenuInfoType === 10 || leftMenuInfoType === 11 || leftMenuInfoType === 12) {
            if (leftMenuInfoType === 10 || leftMenuInfoType === 11 || leftMenuInfoType === 12 || item?.reportMenuType === 1) {
                dispatch(setSubPage('groupTitle-grid'));
            }
            dispatch(
                getMomentReportsGropuTitleGrid({
                    startDate: getDateFormat({ date_: reportFilter?.startDate }),
                    endDate: getDateFormat({ date_: reportFilter?.endDate }),
                    serviceUrl: itemGroupTitle ? itemGroupTitle?.serviceUrl : serviceUrl,
                    companyIdList: reportFilter?.companyIdList,
                    type: itemGroupTitle ? itemGroupTitle?.leftMenuDetailsType : leftMenuInfoType,
                    excelType: excelType,
                    pageSize: 50,
                    pageIndex,
                }),
            );
            dispatch(
                setGroupTitle({
                    startDate: getDateFormat({ date_: reportFilter?.startDate }),
                    endDate: getDateFormat({ date_: reportFilter?.endDate }),
                    serviceUrl: itemGroupTitle ? itemGroupTitle?.serviceUrl : serviceUrl,
                    companyIdList: reportFilter?.companyIdList,
                    type: itemGroupTitle ? itemGroupTitle?.leftMenuDetailsType : leftMenuInfoType,
                    excelType: excelType,
                    loading: false,
                }),
            );
        }
    };

    const handleClickGruopTitleDetail = itemDetail => {
        setActiveMenuType(item?.reportMenuType)
        const serviceUrl = itemDetail?.serviceUrl;
        const leftMenuDetailsType = itemDetail?.leftMenuDetailsType;
        const startDate = reportFilter?.startDate;
        const endDate = reportFilter?.endDate;
        const companyIdList = reportFilter?.companyIdList;
        dispatch(setGroupTitle({ startDate, endDate, companyIdList, leftMenuDetailsType, serviceUrl, loading: true }));
        handleClickToFeed({ itemGroupTitle: itemDetail, leftMenuInfoType: leftMenuDetailsType, title: itemDetail?.title, excelType: itemDetail?.excelType});
    };

    return (
        <div
            className={
                item?.reportMenuType === 2 || item?.reportMenuType === 1
                    ? 'button-11 padding-zero'
                    : activeMenuType === item?.reportMenuType && item?.reportMenuType < 1
                        ? 'button-11 active'
                        : 'button-11'
            }>
            {item?.reportMenuType === 0 && (
                <button
                    disabled={filterModalOpen}
                    className="dashboard-stil"
                    onClick={() => handleClickToFeed({ title: '', leftMenuInfoType: '', itemGroupTitle: null, excelType: item?.excelType })}>
                    <img className="img-01" src={item?.icon} alt={item?.title} />
                    <span className="text-01">{item?.title}</span>

                    {activeMenuType === item?.reportMenuType && <div className="f-underline" />}
                </button>
            )}

            {/* //!  progressbar */}
            {item?.reportMenuType === 1 && !item?.icon && (
                <Accordion
                    disabled={filterModalOpen}
                    className="report-accordion-menu-01"
                    key={item?.id}
                    expanded={expanded === 'panel-' + item?.displayOrder}
                    onChange={handleChange('panel-' + item?.displayOrder)}>
                    <AccordionSummary className="accordion-summary py-2" expandIcon="" aria-controls="panel7a-content" id="panel7a-header">
                        <div className="c-item-01 percantage-menu-button">
                            <div className="circular-progressbar">
                                <CircularProgressbar value={item?.value} text={`%${item?.value}`} />
                            </div>
                            <span className="text-01">{item?.title}</span>
                            <div className={expanded === 'panel-' + item?.displayOrder ? 'c-item-01-C active' : 'c-item-01-C'}>
                                <svg className="c-unit-01" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 18L15 12L9 6" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        </div>
                    </AccordionSummary>
                    {item?.details?.map((itemDetail, idx) => (
                        <AccordionDetails
                            key={'notifications-grid- ' + idx}
                            className={
                                //groupTitle-grid
                                (page.subPage === 'notifications-grid' || page.subPage === 'groupTitle-grid') &&
                                    notficationType === itemDetail?.leftMenuInfoType
                                    ? 'accordion-details-notifications active'
                                    : 'accordion-details-notifications'
                            }>
                            <button
                                onClick={() => {
                                    handleClickToFeed({
                                        title: itemDetail?.title,
                                        leftMenuInfoType: itemDetail?.leftMenuInfoType,
                                        serviceUrl: itemDetail?.serviceUrl,
                                        itemGroupTitle: null,
                                        excelType: itemDetail?.excelType
                                    })
                                    setActiveMenuType(item?.reportMenuType)
                                }}
                                className="button-notifications">
                                <p className="text-01">{itemDetail?.title}</p>
                            </button>
                        </AccordionDetails>
                    ))}
                </Accordion>
            )}
            {item?.reportMenuType === 2 && (
                <Accordion
                    disabled={filterModalOpen}
                    className="report-accordion-menu-01"
                    key={item?.id}
                    expanded={expanded === 'panel-' + item?.displayOrder}
                    onChange={handleChange('panel-' + item?.displayOrder)}>
                    <AccordionSummary className="accordion-summary" expandIcon="" aria-controls="panel7a-content" id="panel7a-header">
                        <div className="c-item-01">
                            <img className="c-item-img" src={item?.icon} alt="" />
                            <h6 className="c-item-01-A">{item?.title}</h6>
                            <div className={expanded === 'panel-' + item?.displayOrder ? 'c-item-01-C active' : 'c-item-01-C'}>
                                <svg className="c-unit-01" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 18L15 12L9 6" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        </div>
                    </AccordionSummary>

                    {item?.details?.map((itemDetail, idx) => (
                        <AccordionDetails
                            key={'notifications-grid- ' + idx}
                            className={
                                //groupTitle-grid
                                (page.subPage === 'notifications-grid' || page.subPage === 'groupTitle-grid') &&
                                    notficationType === itemDetail?.leftMenuInfoType
                                    ? 'accordion-details-notifications active'
                                    : 'accordion-details-notifications'
                            }>
                            <button
                                onClick={() => {
                                    handleClickToFeed({
                                        title: itemDetail?.title,
                                        leftMenuInfoType: itemDetail?.leftMenuInfoType,
                                        serviceUrl: itemDetail?.serviceUrl,
                                        itemGroupTitle: null,
                                        excelType: itemDetail?.excelType
                                    })
                                    setActiveMenuType(item?.reportMenuType)
                                }}
                                className="button-notifications">
                                <p className="text-01">{itemDetail?.title}</p>
                                {/* {page.subPage === 'notifications-grid' && notficationType === i?.leftMenuInfoType && <div className="f-underline" />} */}
                            </button>
                        </AccordionDetails>
                    ))}
                </Accordion>
            )}
            {/* //! GroupTitle -  left corner side */}
            {item?.reportMenuType === 3 && (
                <div className="accordion-group">
                    {item?.details?.map((item_, index) => (
                        <Accordion
                            disabled={filterModalOpen}
                            className={index === 0 ? 'report-accordion-menu-02 f-pointer-event-none' : 'report-accordion-menu-02'}
                            key={'report-accordion-menu-02-' + index}
                            expanded={expanded === 'panel' + index + 1}
                            onChange={handleChange('panel' + index + 1)}>
                            <AccordionSummary className="accordion-summary" expandIcon="" aria-controls="panel7a-content" id="panel7a-header">
                                <div className="c-item-01">
                                    <img src={item_?.icon} alt={item?.title} />
                                    <h6 className="c-item-01-A">{item_?.title}</h6>
                                    {/* <div className="c-item-01-B">
                                        <p className="c-unit">{item_?.value}</p>
                                    </div> */}
                                    <div className={expanded === 'panel' + index + 1 ? 'c-item-01-C active' : 'c-item-01-C'}>
                                        <svg
                                            className="c-unit-01"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9 18L15 12L9 6" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                            </AccordionSummary>
                            {item_?.details?.map(itmDetail => (
                                <AccordionDetails
                                    key={itmDetail?.id}
                                    className={
                                        page.subPage === 'groupTitle-grid' && notficationType === itmDetail?.leftMenuDetailsType
                                            ? 'accordion-details active'
                                            : 'accordion-details'
                                    }>
                                    <button onClick={() => handleClickGruopTitleDetail(itmDetail)} className="button-accordion-details">
                                        <p>{itmDetail?.title}</p>
                                    </button>
                                </AccordionDetails>
                            ))}
                        </Accordion>
                    ))}
                </div>
            )}
        </div>
    );
};

export default AsideMenu;
